import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useNonComplianceActionsList } from '../../../../utils/actions/nonCompliance/list'
import { useNonCompliances } from '../_load/NonCompliancesLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const nonCompliances = useNonCompliances()
  const { getSelectedData } = useMultiSelectState()
  const selectedNonCompliances = getSelectedData(nonCompliances)
  const [menuOptions, loading] = useNonComplianceActionsList(head(selectedNonCompliances), selectedNonCompliances)

  return <MultiSelectMenu loading={loading} options={menuOptions} />
}

export default MultiRowsActions
